









































































  import Routes from '@/router/routes';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'BanniereUlaval',
    data: function () {
      return {
        routeAccueil: Routes.Accueil,
        routeDeconnexion: Routes.Deconnecter,
      };
    },
  });
